














import { Component, Vue, Prop } from 'vue-property-decorator';
const TEAMS_PER_ROW = 5;
const LOGO_WIDTH = 51;
const LOGO_HEIGHT = 52;
@Component({
    components: {
    },
})
export default class TeamImage extends Vue {
    @Prop() private item!: any;
    @Prop() private listMode?: boolean;
    @Prop() private pitchMode?: boolean;

    private playerTypeNames  = ['GK', 'DF', 'MD', 'FW'];

    private getImageUrl(image: string) {
        if (image) {
            return require('../../../assets/images/' + image.toLowerCase() + '.png');
        }
    }

    get xPosition() {
        return -1 * (this.item.spritePosition % TEAMS_PER_ROW * LOGO_WIDTH - LOGO_WIDTH) + 'px';
    }

    get yPosition() {
        return -1 * (Math.ceil(this.item.spritePosition / TEAMS_PER_ROW) * LOGO_HEIGHT - LOGO_HEIGHT) + 'px';
    }

}
